import { useContext } from 'react';
import ClientContext, { CallbackContextType } from './CallbackContext';

export default (): CallbackContextType => useContext<CallbackContextType>(ClientContext);
